"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Download;

var _Download = require("@adobe/react-spectrum-workflow/dist/Download");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Download(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Download.A4uDownload, null));
}